<!--
 * @Descripttion: 柱状图
 * @Author: zenghua.wang
 * @Date: 2021-05-27 14:03:46
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 17:04:34
-->
<template>
  <div
    ref="container"
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :ref="id"
      :style="styleChart"
    ></div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import echart from '@/dragComponents/mixins/echart'
import {
  isEmpty,
  deepClone,
  isHasProp,
  setTooltipFormatter
} from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-echart-bar',
  mixins: [bem, echart],
  directives: { customLoading },
  data() {
    return {
      component: component
    }
  },
  methods: {
    setOption() {
      const optionData = deepClone(this.optionData)
      const isGroup = !isEmpty(this.getGroup())
      const source = isGroup ? deepClone(optionData.series) : []

      let option = {
        title: isHasProp(
          this.option.titleShow,
          {
            text: this.option.titleText,
            subtext: this.option.titleSubtext,
            textStyle: {
              color: this.option.titleTextColor,
              fontSize: this.option.titleTextFontSize * (window?.scale || 1)
            },
            left: this.option.titleLeft || 'auto',
            top: this.option.titleTop || 'auto',
            subtextStyle: {
              color: this.option.titleSubtextColor,
              fontSize: this.option.titleSubtextFontSize * (window?.scale || 1)
            }
          },
          {}
        ),
        tooltip: isHasProp(
          !isEmpty(this.option.tipFormatter),
          {
            formatter: (params) => {
              return setTooltipFormatter(
                this.option.tipFormatter,
                params,
                this.dataList
              )
            }
          },
          {
            show: this.option.tipShow,
            // params: item是object，axis是array
            // trigger: 'item',
            // axisPointer: {
            //   type: 'cross'
            // },
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor
            }
          }
        ),
        grid: {
          left: this.option.gridLeft,
          top: this.option.gridTop,
          right: this.option.gridRight,
          bottom: this.option.gridBottom
        },
        legend: {
          show: this.option.legendShow,
          top: !isEmpty(this.option.legendTop)
            ? this.option.legendTop + '%'
            : 10,
          left: this.option.legendLeft,
          orient: this.option.legendOrient || 'horizontal',
          textStyle: {
            fontSize: this.option.legendFontSize
          }
        },
        xAxis: Object.assign(
          (() => {
            if (isGroup) {
              return {}
            } else {
              return {
                data: optionData.categories || []
              }
            }
          })(),
          {
            type: this.option.showCategory ? 'value' : 'category',
            name: this.option.showCategory
              ? this.option.yAxisName
              : this.option.xAxisName,
            nameTextStyle: {
              color: this.option.xAxisNameColor,
              fontSize: this.option.xAxisNameFontSize
            },
            show: this.option.xAxisShow,
            inverse: this.option.xAxisInverse,
            axisLine: {
              show: this.option.xAxisLine,
              // symbol: ['none', 'arrow'],
              symbolSize: [5, 10],
              symbolOffset: [0, 5],
              lineStyle: {
                color: this.option.lineColor
              }
            },
            axisTick: {
              show: this.option.xAxisTickShow,
              length: 5
            },
            axisLabel: {
              show: this.option.xAxisLabelShow,
              interval: this.option.xAxisInterval || 'auto',
              rotate: this.option.xAxisLabelRotate,
              color: this.option.lineColor,
              fontSize: this.option.lineFontSize
            },
            splitLine: {
              show: this.option.xAxisSplitLineShow
            }
          }
        ),
        yAxis: Object.assign(
          (() => {
            if (isGroup) {
              return {}
            } else {
              return {
                data: optionData.categories || []
              }
            }
          })(),
          {
            type: this.option.showCategory ? 'category' : 'value',
            name: this.option.showCategory
              ? this.option.xAxisName
              : this.option.yAxisName,
            nameTextStyle: {
              color: this.option.yAxisNameColor,
              fontSize: this.option.yAxisNameFontSize
            },
            show: this.option.yAxisShow,
            inverse: this.option.yAxisInverse,
            axisLine: {
              show: this.option.yAxisLine,
              // symbol: ['none', 'arrow'],
              symbolSize: [5, 10],
              symbolOffset: [0, 5],
              lineStyle: {
                color: this.option.lineColor
              }
            },
            axisTick: {
              show: this.option.yAxisTickShow,
              length: 5
            },
            axisLabel: {
              show: this.option.yAxisLabelShow,
              interval: this.option.yAxisInterval || 'auto',
              rotate: this.option.yAxisLabelRotate,
              color: this.option.lineColor,
              fontSize: this.option.lineFontSize
            },
            splitLine: {
              show: this.option.yAxisSplitLineShow
            }
          }
        ),
        dataset: {
          dimensions: optionData.categories || [],
          source: source
        },
        series: (() => {
          const list = (optionData.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: this.option.type,
              stack: ele.stack,
              barWidth: this.option.barWidth || 4,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: {
                borderRadius: this.option.borderRadius || 0,
                color: this.getColor(index)
              },
              label: Object.assign(
                (() => {
                  if (isGroup) {
                    return {}
                  } else {
                    return {
                      // formatter: '{c}',
                      formatter: ({ value }) => {
                        return !isEmpty(this.option.unit)
                          ? value + this.option.unit
                          : value
                      }
                    }
                  }
                })(),
                {
                  show: this.option.labelShow,
                  position: this.option.showCategory ? 'right' : 'top',
                  textStyle: {
                    fontSize: this.option.labelShowFontSize,
                    color: this.option.labelShowColor,
                    fontWeight: this.option.labelShowFontWeight
                  }
                }
              )
            })
          })
          return list
        })()
      }

      // console.log(275, option)

      // 颜色设置
      // if (this.option.defaultColor) {
      //   option.color && delete option.color
      // } else {
      //   option.color = this.option.color
      // }

      this.dragChart.resize()
      this.dragChart.setOption(option, true)
      this.isChart = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(mock.echart.series, mock.echart.categories)
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/echart/index.scss';
</style>
